<template>
    <div class="notice_container">
          <div class="headIcon">
            <van-icon name="arrow-left" @click="goToHome" />
        </div>
        <img src="@/assets/themeThree/K65logo.png" alt="" />
        <p class="titleHead">{{$t('notice.updateNotification')}}</p>
        <div v-html="$t('notice.contentText')"></div>
    </div>
</template>

<script setup lang="ts">
import {} from 'vue'

const emits = defineEmits(['goToHome'])

const goToHome = () => {
    emits('goToHome')
}

</script>
<style scoped>
.notice_container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: #7485aa;
    font-size: 14px;
}

.notice_container img {
    width: 50%;
    padding-bottom: 20px;
}

.headIcon {
    position: fixed;
    top: 20px;
    left: 20px;
    font-size: 25px;
}
.headIcon img{
    width: 50px;
}
.titleHead {
    color: #ffff;
    font-size: 18px;
    font-weight: bold;
}


.text {
  font-size: 1rem;
  font-weight: 500;
}

</style>